module.exports = __webpack_public_path__ + "static/media/iar_responder_other_hover.c1a989e8.svg";